import { useContext } from 'react'
import { INSTITUTE_FIND_BY_NAME } from '../URLs'
import { useQueryHook } from './queryHook'
import { LocaleContext } from '../../components/LocaleContext/LocaleContext'
import { apiGet } from '../api'
import { TDictionaryItems } from '../../interfaces/IDictionary'
import { IInstituteFindByNameAndRegionProps } from '../../interfaces/IInstituteFindByNameAndRegionProps'

export const useInstituteFindByNameAndRegion = (
  searchStringMinLength: number,
  params: IInstituteFindByNameAndRegionProps,
) => {
  const { locale } = useContext(LocaleContext)

  const queryObject = useQueryHook({
    key: [INSTITUTE_FIND_BY_NAME, params.name, params.regionId],
    fetcherFunction: async () => {
      if (params.name.length >= searchStringMinLength && !!params.regionId) {
        const { data } = await apiGet<IInstituteFindByNameAndRegionProps, TDictionaryItems>({
          path: INSTITUTE_FIND_BY_NAME,
          params,
          locale,
        })

        return data
      }

      return Promise.resolve([])
    },
  })

  if (queryObject.isLoading || queryObject.isError) {
    return {
      ...queryObject,
      data: null,
    }
  }

  return {
    ...queryObject,
    data: queryObject.data || null,
  }
}
